module.exports = __webpack_public_path__ + "static/media/12_burger.22666f03.svg";